import React from 'react';
import { useSearch } from '../../contexts/SearchContext';
import { useProduct } from '../../contexts/ProductContext';

const SearchResult = ({ product, isSelected, onSelect }) => {
  const { closeSpotlight, addToRecentSearches } = useSearch();
  const { openProduct } = useProduct();

  const handleClick = () => {
    addToRecentSearches(product.name);
    closeSpotlight();
    openProduct(product.id);
    onSelect(product);
  };

  const highlightMatch = (text, query) => {
    if (!query) return text;
    
    const parts = text.split(new RegExp(`(${query})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <mark key={index} className="bg-yellow-200 text-gray-900">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full px-4 py-3 flex items-center gap-4 hover:bg-gray-50 transition-colors text-left ${
        isSelected ? 'bg-gray-50 border-l-2 border-bmb-text' : ''
      }`}
    >
      {/* Product Image */}
      <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded overflow-hidden">
        {product.imageThumbnail ? (
          <picture>
            <source srcSet={product.imageThumbnail.webp} type="image/webp" />
            <source srcSet={product.imageThumbnail.jpg} type="image/jpeg" />
            <img
              src={product.imageThumbnail.jpg || product.image}
              alt={product.name}
              className="w-full h-full object-cover"
            />
          </picture>
        ) : (
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        )}
      </div>

      {/* Product Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-500 font-mono">
            {highlightMatch(product.sku, product.searchQuery)}
          </span>
          {product.isNew && (
            <span className="text-xs bg-red-500 text-white px-1.5 py-0.5 rounded">
              NOVO
            </span>
          )}
        </div>
        <h3 className="font-medium text-gray-900 truncate">
          {highlightMatch(product.name, product.searchQuery)}
        </h3>
        <p className="text-sm text-gray-600">
          {product.category} {product.material && `• ${product.material}`}
        </p>
      </div>


      {/* Action Hint */}
      <div className="flex-shrink-0">
        <span className="text-xs text-gray-400">↵</span>
      </div>
    </button>
  );
};

export default SearchResult;